import { render, staticRenderFns } from "./PrimerEservs.vue?vue&type=template&id=65395ab5&scoped=true&"
import script from "./PrimerEservs.vue?vue&type=script&lang=js&"
export * from "./PrimerEservs.vue?vue&type=script&lang=js&"
import style0 from "./PrimerEservs.vue?vue&type=style&index=0&id=65395ab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65395ab5",
  null
  
)

export default component.exports